import { FullWidthBox } from '@app/components/base/FullWidthBox';
import { SegmentsAudioPlaybackProvider } from '@app/core/playback/audio/SegmentsAudioPlaybackProvider';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { Box } from '@mui/material';
import { AuditPreviewMarkers } from '../../components/audit/preview-markers/AuditPreviewMarkers';
import { FocusTracks } from '../../components/focus/FocusTracks';
import { StreamPlaybackHotkeysHandler } from '../../components/StreamPlaybackHotkeysHandler';
import { useStreamSegmentsRange } from '../../hooks/segments/useStreamSegmentsQuery';
import { AudioBottomPanel } from './AudioBottomPanel';
import { AudioFocus } from './AudioFocus';
import { AudioPreview } from './AudioPreview';

export function LoggerAudioMode() {
  const station = useActiveStation();
  const range = useStreamSegmentsRange()!;

  return (
    <SegmentsAudioPlaybackProvider playbackId={'logger'} station={station} playbackRange={range}>
      <StreamPlaybackHotkeysHandler />

      {/*
        Negative margin top is used to avoid a big gap in the view
        when there are no preview markers displayed
      */}
      <Box mt={-0.5}>
        <AuditPreviewMarkers />
      </Box>

      <FullWidthBox>
        <AudioPreview />
        <AudioFocus />
        <Box my={1}>
          <FocusTracks />
        </Box>
      </FullWidthBox>

      <AudioBottomPanel />
    </SegmentsAudioPlaybackProvider>
  );
}
